import './style.scss'

import TableTeamsInvite from 'components/molecules/TableTeamsInvite'
import { TeamSideId } from 'features/team/const'
import { teamHooks, TeamUI } from 'features/team/index.ts'
import { Redirect } from 'react-router-dom'
import { leftSideHooks } from 'shared/hooks'

import { useLegacyPersonas } from '../useLegacyPersonas'

export function InvitedPage() {
	const showMembers = teamHooks.useIsEnable()
	const hasInvited = teamHooks.useHasInvited()

	const [personas, { isSuccess, refetch }] = useLegacyPersonas()

	leftSideHooks.useActive(TeamSideId.Invites)
	const noInviteMembers = isSuccess && !hasInvited

	if (!showMembers || noInviteMembers) {
		return <Redirect to='/team/members' />
	}

	return (
		<TeamUI.Wrapper
			header={
				<div className='flex-container-team-invitation'>
					<h2 className='teams-main-title-invitation'>Pending invites</h2>
				</div>
			}
		>
			<TableTeamsInvite getPersonas={refetch} personas={personas} />
		</TeamUI.Wrapper>
	)
}
